"use strict";

window.swalConfirm = function (element) {
    const parent = element.parentElement;
    $.each(parent.children, (index, value) => {
        if(value.classList.contains('product-name')) {
            Swal.fire({
                title: 'Möchten Sie dieses Produkt wirklich entfernen?',
                text: value.innerText,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Ja',
                confirmButtonColor: '#5bb57f',
                denyButtonText: 'Nein',
                denyButtonColor: '#ac1f2d',
                focusConfirm: false,
                focusDeny: true,
                customClass: {
                    actions: 'confirm-actions',
                    confirmButton: 'confirm',
                    denyButton: 'deny',
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    element.removeAttribute('onclick');
                    element.click();
                }
            });
        }
    });
}
